//Imports
import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo, faTimes } from '@fortawesome/free-solid-svg-icons';
//Css
import './style.css';
//
export default function ModalAlert(props){
    const [ isShow, setIsShow ] = useState(props.isShow);
    useEffect(()=>{
        setIsShow(props.isShow);
    },[props]);
    return (
        <>
            <Row className='justify-content-md-center align-items-center' style={isShow ? {opacity:'1'} : {opacity:'0'}}>
                <Col xs={5} sm={5} md={5} lg={5} xl={5}>
                    <Card className='modal_alert shadow ml-auto mr-auto'>
                        <Card.Header className="p-4">
                                <FontAwesomeIcon icon={faInfo} size={props.size} className="mr-2" style={{float: 'left'}}/>
                                <h6 style={{color: '#FFFFFF'}}>
                                    {props.title ? props.title : 'Informação'}
                                    <FontAwesomeIcon onClick={()=>setIsShow(false)} icon={faTimes} size={props.size} className="mr-2 modal_close" style={{float: 'right'}}/>
                                </h6>
                                
                        </Card.Header>
                        <Card.Body>
                            <h6 style={{textAlign:'center'}}>{props.message}</h6>
                            <Button onClick={props.onClick} className="button_colored mt-5 w-100 modal_button">
                                Ok
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    )
}